export default __webpack_public_path__ + "static/media/trading.7ea1604c.jpg";